import { timerHelperModule } from '../../helpers/timer-helper';
import * as EventUtils from '../../utils/event-utils';

import './intercom-service.less';

// Intercom is no longer used. This module remains as a compatibility layer for
// existing support entrypoints (eg. `intercom-button`) and now routes users to
// email-based support.
export const intercomServiceModule = angular
  .module('Q.services.intercom-service', [timerHelperModule])
  .factory(
    'intercomService',
    function ($window, timerHelper, $rootScope, $log) {
      const SUPPORT_EMAIL = 'support@qualified.io';
      const DEFAULT_SUBJECT = 'Qualified Support';

      let updateTimer = null;

      function buildMailtoHref({ subject, body } = {}) {
        const params = [];
        if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
        if (body) params.push(`body=${encodeURIComponent(body)}`);
        const query = params.length ? `?${params.join('&')}` : '';
        return `mailto:${SUPPORT_EMAIL}${query}`;
      }

      function openMailto({ subject, body } = {}) {
        try {
          $window.location.href = buildMailtoHref({ subject, body });
        } catch (e) {
          // Don't break the UI if navigation fails in some embedded contexts.
          $log.debug(e);
        }
      }

      let service = {
        // Compatibility no-ops (Intercom removed)
        setUser() {
          $rootScope.$broadcast('intercom.isActive', false);
          return service;
        },
        unsetUser() {
          $rootScope.$broadcast('intercom.isActive', false);
          return service;
        },
        trackPage() {
          return service;
        },
        trackEvent() {
          return service;
        },
        delayUpdate(delay, data) {
          timerHelper.longTimeout.cancel(updateTimer);

          updateTimer = timerHelper.longTimeout(
            function () {
              service.update(data);
            },
            delay || 2000,
            false,
          );
        },
        update() {
          return service;
        },
        show(msg) {
          let body = '';
          if (msg && msg !== true) body = String(msg);
          openMailto({ subject: DEFAULT_SUBJECT, body });
          return service;
        },
        hide() {
          return service;
        },
        toggle() {
          return service.show();
        },
        isActive() {
          return false;
        },
        showWidget() {
          // Always allow support entrypoints to render, even though Intercom is gone.
          return true;
        },
        supportMailtoHref({ subject, body } = {}) {
          return buildMailtoHref({
            subject: subject || DEFAULT_SUBJECT,
            body,
          });
        },
      };

      return service;
    },
  )
  .run(function ($rootScope, intercomService) {
    $rootScope.$on('$stateChangeSuccess', () =>
      intercomService.delayUpdate(1000),
    );
  })
  .directive('intercomHide', function () {
    return {
      restrict: 'A',
      link(scope, elem) {
        // Intercom is removed, but keep the element visible for support entrypoints.
        elem.toggleClass('ng-hide', false);
      },
    };
  })
  .directive('intercomButton', function (intercomService) {
    return {
      restrict: 'A',
      link(scope, elem, attr) {
        elem.addClass('intercom-button');
        elem.attr('tabindex', 0);
        const msgAttr = attr.intercomButtonMessage;
        const msg = msgAttr === 'true' || msgAttr === '' ? '' : msgAttr;

        const existingHref = elem.attr('href');
        const shouldSetHref =
          !existingHref || existingHref === '' || existingHref === '#';
        if (shouldSetHref) {
          elem.attr('href', intercomService.supportMailtoHref({ body: msg }));
          elem.attr('target', '_blank');
          elem.attr('rel', 'noopener');
        }

        // Ensure mailto works even if something prevents default navigation.
        elem.on('click', (event) => {
          if (shouldSetHref) {
            EventUtils.stopEvent(event);
            intercomService.show(msg);
          }
        });
        if (!attr.title && !attr.tooltip) {
          elem.attr('title', 'Email Qualified Support');
        }
      },
    };
  })

  .directive('modalContent', function ($compile) {
    return {
      restrict: 'C',
      link(scope, elem) {
        let nodeLink = $compile(
          `<a intercom-button track-click="Support Email Clicked" track-data="{ui: {region: 'dialog'}}"></a>`,
        )(scope);
        elem.append(nodeLink);
      },
    };
  });
